import isFn from 'utils/predicates/function/isFn.util';

const sortArray = (comparator, array) => {
  // maybe there was only one argument provided, in that case, comparator is the actual array to be sorted
  if (!Array.isArray(array)) array = comparator;

  // but even in that case, if there is no array provided, just return an empty one
  if (!Array.isArray(array)) return [];

  const sorted = [...array];

  if (isFn(comparator)) {
    sorted.sort(comparator);
  } else {
    sorted.sort();
  }

  return sorted;
};

export default sortArray;
